<p-sidebar [(visible)]="display" position="right" styleClass=" w-full md:w-30rem lg:w-4">
<!--	<ng-template pTemplate="header">
		<div class="font-bold text-2xl">
			<div [ngSwitch]="index">
				<div *ngSwitchCase="0">
					{{ 'components.app-authentication-manager.login-header' | translate }}
				</div>
				<div *ngSwitchCase="1">
					{{ 'components.app-authentication-manager.register-header' | translate }}
				</div>
				<div *ngSwitchCase="2">
					{{ 'components.app-authentication-manager.reset-pass-header' | translate }}
				</div>
				<div *ngSwitchCase="3">
					{{ 'components.app-authentication-manager.efectuar-tramite-empresa' | translate }}
				</div>
			</div>
		</div>

	</ng-template>-->
	<ng-template pTemplate="content">
		<div class="flex flex-column gap-3 mt-6" [ngClass]="{'mt-6': index != 1}">

      <div class="mx-auto container-width-sidebar">
        <img class="w-full h-auto" draggable="false"
             [src]="'assets/img/icons-principal/logo-header-main.png'"
             alt="Portal de Trámites Gobernación del Magdalena" />
      </div>
			<div class="flex justify-content-between pt-2 mx-auto
			 container-width-sidebar time-location-container">
				<div class="flex gap-1 align-items-center">
					<i class="pi pi-calendar" style="font-size: 1.4rem; color: var(--gray);"></i>
					<p class="text-gray my-0" style="font-size:13px">
						{{currentTime | date: 'dd/MM/YYYY'}}
					</p>
				</div>
        <div class="flex gap-1 align-items-center">
					<i class="pi pi-clock text-gray" style="font-size: 1.4rem;"></i>
          <p class="text-gray my-0" style="font-size:13px">
						{{currentTime | date: 'HH:mm'}}
					</p>
				</div>
				<div class="flex gap-1 align-items-center">
					<i class="pi pi-globe text-gray" style="font-size: 1.4rem;"></i>
          <p class="text-gray my-0" style="font-size:11px">
						{{location}}
					</p>
				</div>
			</div>
		<div [ngSwitch]="index">
			<div *ngSwitchCase="0">
				<app-login-form></app-login-form>
			</div>
			<div *ngSwitchCase="1">
				<app-register-form></app-register-form>
			</div>
			<div *ngSwitchCase="2">
				<app-password-reset-form></app-password-reset-form>
			</div>
			<div *ngSwitchCase="3">
				<app-efectuar-tramite-empresa-form></app-efectuar-tramite-empresa-form>
			</div>
		</div>
	</div>
	</ng-template>
</p-sidebar>
